import { ComponentPropsWithoutRef } from "react";
import cn from "../../util/cn";

type PatientDataCellProps = {
  rowIndex: number;
  className?: string;
} & ComponentPropsWithoutRef<"div">;

const PatientDataCell = ({
  rowIndex: index,
  className,
  children,
  ...otherProps
}: PatientDataCellProps) => (
  <div
    className={cn(
      "flex items-center text-nowrap border-b border-gray-200 py-4 font-medium text-primary/90",
      index % 2 === 0 ? "bg-gray-50" : "",
      className
    )}
    {...otherProps}
  >
    {children}
  </div>
);

export default PatientDataCell;
